(function () {
  'use strict';

  // Deliberate product decision from 2026-09-10 (commit d1a9d061, "Hide the
  // category filter groups on collection and search rails"): the rail, its
  // chips, and every request built from PUBLIC_GROUPS below must never
  // expose these two engine group slugs. Delete this line and the
  // .filter(...) call directly below to re-enable them.
  var EXCLUDED_PUBLIC_GROUPS = ['category', 'product-category'];
  var PUBLIC_GROUPS = [
    'product-category',
    'category',
    'brand',
    'series',
    'amps',
    'poles',
    'voltage',
    'mounting',
    'trip_technology',
    'condition',
    'aic_min'
  ].filter(function (group) { return EXCLUDED_PUBLIC_GROUPS.indexOf(group) === -1; });
  var PUBLIC_GROUP_SET = new Set(PUBLIC_GROUPS);
  // Chip display order for breaker collections. PUBLIC_GROUPS stays the
  // permission list; this array is applied only when the chip container
  // carries data-sfs-group-order="breaker". Kept in lockstep with the
  // pre-paint script in collection-search-active-filters.liquid.
  var BREAKER_GROUP_ORDER = ['brand', 'amps', 'series', 'poles', 'voltage', 'mounting'];

  function orderedChipGroups(controls) {
    if (!controls || controls.getAttribute('data-sfs-group-order') !== 'breaker') {
      return PUBLIC_GROUPS;
    }
    var preferred = [];
    var remaining = [];
    PUBLIC_GROUPS.forEach(function (group) {
      if (BREAKER_GROUP_ORDER.indexOf(group) !== -1) preferred.push(group);
      else remaining.push(group);
    });
    preferred.sort(function (a, b) {
      return BREAKER_GROUP_ORDER.indexOf(a) - BREAKER_GROUP_ORDER.indexOf(b);
    });
    return preferred.concat(remaining);
  }
  var OPTION_SEARCH_GROUP_SET = new Set(['brand', 'series']);
  var SORTS = new Set([
    'best-selling',
    'title-ascending',
    'title-descending',
    'price-ascending',
    'price-descending'
  ]);
  var PAGE_SIZES = new Set([5, 8, 10, 12, 15, 20, 24, 48]);
  var MAX_VALUES_PER_GROUP = 12;
  var MAX_TOTAL_VALUES = 20;
  var MAX_LABEL_LENGTH = 100;
  var MAX_OPTION_RESULTS = 40;
  var MAX_OPTION_ROWS = 96;
  var GROUP_HEAD_SIZE = 12;
  var SHOW_MORE_MIN_REMAINING = 3;
  var OPTION_SEARCH_DELAY_MS = 250;
  var RESULT_TIMEOUT_MS = 2500;
  var OPTION_TIMEOUT_MS = 1500;
  var OPTION_CACHE_TTL_MS = 30000;
  var OPTION_CACHE_LIMIT = 64;
  var UNSAFE_LABEL = /[\u0000-\u001f\u007f<>{}%]/;
  var instanceCount = 0;

  // A group Liquid never bootstrapped (see materializeMissingGroupBlocks)
  // still needs a readable heading -- payload.groups carries raw VALUE
  // labels only, never a group display label. This table is a plain data
  // lookup, not a branch on group identity: any slug missing from it still
  // renders through the exact same humanizeGroupSlug fallback below, so a
  // brand-new engine group needs zero code changes to render, just an
  // optional, later entry here for nicer copy.
  var GROUP_LABEL_OVERRIDES = {
    aic_min: 'Interrupting Rating (min)'
  };

  function humanizeGroupSlug(slug) {
    var raw = String(slug || '');
    if (GROUP_LABEL_OVERRIDES[raw]) return GROUP_LABEL_OVERRIDES[raw];
    var words = raw.split(/[_-]+/).filter(Boolean);
    if (!words.length) return raw;
    var suffix = '';
    var last = words[words.length - 1];
    if (words.length > 1 && (last === 'min' || last === 'max')) {
      suffix = ' (' + last + ')';
      words = words.slice(0, -1);
    }
    var titled = words.map(function (word) {
      if (word.length <= 3 && /^[a-z0-9]+$/.test(word)) return word.toUpperCase();
      return word.charAt(0).toUpperCase() + word.slice(1);
    }).join(' ');
    return (titled || raw) + suffix;
  }

  // The engine's own key order in the availability payload is the only
  // signal this client has for where a group belongs relative to its
  // siblings -- PUBLIC_GROUPS is a fixed permission list, not a layout
  // order. Filtered to permitted, well-formed groups only.
  function orderedAvailabilityGroupKeys(payload) {
    return Object.keys(payload.groups).filter(function (group) {
      return PUBLIC_GROUP_SET.has(group) && Array.isArray(payload.groups[group]);
    });
  }

  function cleanLabel(value) {
    if (typeof value !== 'string') return '';
    var label = value.replace(/\s+/g, ' ').trim();
    if (!label || label.length > MAX_LABEL_LENGTH || UNSAFE_LABEL.test(label)) return '';
    return label;
  }

  function pageNumber(raw) {
    var value = parseInt(String(raw || '1'), 10);
    if (!Number.isFinite(value) || value < 1) return 1;
    return Math.min(value, 10000);
  }

  function normalizeSort(raw) {
    return SORTS.has(raw) ? raw : 'best-selling';
  }

  function pageSize(raw) {
    var value = parseInt(String(raw || '20'), 10);
    return PAGE_SIZES.has(value) ? value : 20;
  }

  function normalizeFilters(raw) {
    var filters = {};
    var total = 0;
    PUBLIC_GROUPS.forEach(function (group) {
      if (total >= MAX_TOTAL_VALUES) return;
      var source = raw && Array.isArray(raw[group]) ? raw[group] : [];
      var values = [];
      source.slice(0, MAX_VALUES_PER_GROUP).forEach(function (value) {
        var label = cleanLabel(value);
        if (label && values.indexOf(label) === -1 && total < MAX_TOTAL_VALUES) {
          values.push(label);
          total += 1;
        }
      });
      if (values.length) filters[group] = values;
    });
    return filters;
  }

  function normalizeState(raw) {
    return {
      filters: normalizeFilters(raw && raw.filters),
      sort: normalizeSort(raw && raw.sort),
      page: pageNumber(raw && raw.page)
    };
  }

  function cloneState(state) {
    var filters = {};
    PUBLIC_GROUPS.forEach(function (group) {
      if (state.filters[group]) filters[group] = state.filters[group].slice();
    });
    return { filters: filters, sort: state.sort, page: state.page };
  }

  function stateKey(state) {
    var normalized = normalizeState(state);
    return JSON.stringify([
      normalized.sort,
      normalized.page,
      PUBLIC_GROUPS.map(function (group) { return normalized.filters[group] || []; })
    ]);
  }

  function filterStateKey(state) {
    var normalized = normalizeState(state);
    return JSON.stringify(PUBLIC_GROUPS.map(function (group) {
      return normalized.filters[group] || [];
    }));
  }

  function optionContextKey(group, state) {
    var normalized = normalizeState(state);
    return JSON.stringify(PUBLIC_GROUPS.filter(function (candidate) {
      return candidate !== group;
    }).map(function (candidate) {
      return normalized.filters[candidate] || [];
    }));
  }

  function hasSelections(state) {
    return PUBLIC_GROUPS.some(function (group) {
      return !!(state.filters[group] && state.filters[group].length);
    });
  }

  function selectedCount(state) {
    return PUBLIC_GROUPS.reduce(function (count, group) {
      return count + (state.filters[group] ? state.filters[group].length : 0);
    }, 0);
  }

  function sameBaseState(left, right) {
    return stateKey(left) === stateKey(right);
  }

  function importChildren(source) {
    return Array.prototype.map.call(source.childNodes, function (node) {
      return document.importNode(node, true);
    });
  }

  function normalizedSearchText(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .trim()
      .replace(/\s+/g, ' ');
  }

  // A row can be hidden by two independent gates: the availability payload
  // from the last committed response, and the text typed into the group
  // option search. Both are recomputed here so neither gate can clear the
  // other one.
  function rowTextHidden(row, normalizedQuery) {
    if (!normalizedQuery) return false;
    var link = row.querySelector('[data-sfs-filter-link]');
    var label = link ? normalizedSearchText(link.dataset.sfsLabel) : '';
    return label.indexOf(normalizedQuery) === -1;
  }

  function syncRowHidden(row, normalizedQuery) {
    row.hidden = row.hasAttribute('data-sfs-unavailable') ||
      rowTextHidden(row, normalizedQuery);
  }

  class CollectionSearchFilters extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.instanceId = ++instanceCount;
      this.dynamicOptionCount = 0;
      this.collectionHandle = cleanLabel(this.dataset.collectionHandle);
      this.collectionUrl = this.dataset.collectionUrl || window.location.pathname;
      this.endpoint = this.dataset.endpoint || '/a/search';
      this.gridId = this.dataset.gridId || '';
      this.pageSize = pageSize(this.dataset.pageSize);
      this.status = this.querySelector('[data-sfs-collection-status]');
      this.controller = null;
      this.pendingLoad = null;
      this.optionControllers = new Map();
      this.optionTimers = new Map();
      this.optionPending = new Map();
      this.optionSequences = new Map();
      this.optionCache = new Map();
      this.availableOptions = new Map();
      // Groups this instance itself built because bootstrap never rendered
      // them (see materializeMissingGroupBlocks).
      this.dynamicGroups = new Set();
      this.boundClick = this.onClick.bind(this);
      this.boundChange = this.onChange.bind(this);
      this.boundInput = this.onOptionSearch.bind(this);
      this.boundPopState = this.onPopState.bind(this);
      this.boundSortOutsideClick = this.onSortOutsideClick.bind(this);
      this.boundSortKeydown = this.onSortKeydown.bind(this);

      if (!this.collectionHandle || !/^[a-z0-9-]+$/.test(this.collectionHandle)) return;

      var initialUrl = new URL(window.location.href);
      this.currentState = this.stateFromVisibleUrl(initialUrl);
      this.desiredState = cloneState(this.currentState);
      this.initialSnapshot = this.captureInitialSnapshot(this.currentState, initialUrl);
      // Shopify does not apply custom sfs_ parameters to the initial grid.
      this.renderedState = this.hasNativeFilterParams(initialUrl) ? cloneState(this.currentState)
        : normalizeState({ filters: {}, sort: this.currentState.sort, page: this.currentState.page });
      this.addEventListener('click', this.boundClick, true);
      this.addEventListener('change', this.boundChange, true);
      this.addEventListener('input', this.boundInput);
      this.addEventListener('keydown', this.boundSortKeydown, true);
      document.addEventListener('click', this.boundSortOutsideClick, true);
      window.addEventListener('popstate', this.boundPopState);
      this.renderedUrl = this.hasNativeFilterParams(initialUrl) ? initialUrl.toString()
        : this.visibleUrl(this.renderedState).toString();
      this.syncControls();
      if (window.SFSNativeFallback && window.SFSNativeFallback.enabled() && window.SFSNativeFallback.initializeNativeCollection(this)) return;

      // Unknown native constraints keep Shopify ownership. Verified pole
      // links map to public labels without combining leftover custom filters.
      if (this.hasUnsupportedNativeFilters(initialUrl)) return;

      // Shopify renders the first product grid and this rail. The proxy is
      // only needed when a public filter is already present in a shared URL.
      if (hasSelections(this.currentState)) {
        // A group that already holds a selection can only ever show those
        // selected values in the current result set. Apply that restriction
        // from the URL now, before the engine payload arrives, so the
        // Liquid bootstrap list does not sit fully visible until fetch.
        // The payload is PARTIAL: it names only groups that already hold a
        // selection. Every omitted group must stay as last rendered until
        // a complete engine payload arrives.
        var firstPaintGroups = {};
        PUBLIC_GROUPS.forEach(function (group) {
          if (this.currentState.filters[group] && this.currentState.filters[group].length) {
            firstPaintGroups[group] = this.currentState.filters[group].slice();
          }
        }.bind(this));
        this.applyAvailability({ groups: firstPaintGroups }, this.currentState, { partial: true });
        this.load(this.currentState, {
          historyMode: this.hasNativeFilterParams(initialUrl) ? 'replace' : 'none'
        });
      }
    }

    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      this.optionControllers.forEach(function (controller) { controller.abort(); });
      this.optionTimers.forEach(function (timer) { window.clearTimeout(timer); });
      this.pendingLoad = null;
      this.optionPending.clear();
      if (this.boundPopState) window.removeEventListener('popstate', this.boundPopState);
      if (this.boundSortOutsideClick) document.removeEventListener('click', this.boundSortOutsideClick, true);
    }

    stateFromVisibleUrl(url) {
      var helper = window.SFS_ACTIVE_FILTERS;
      if (helper && typeof helper.parseUrl === 'function') {
        return normalizeState({
          filters: helper.parseUrl(url).filters,
          sort: url.searchParams.get('sort_by') || this.dataset.initialSort,
          page: url.searchParams.get('page')
        });
      }
      var filters = {};
      PUBLIC_GROUPS.forEach(function (group) {
        var values = url.searchParams.getAll('sfs_' + group).map(cleanLabel).filter(Boolean);
        if (values.length) filters[group] = values;
      });
      return normalizeState({
        filters: filters,
        sort: url.searchParams.get('sort_by') || this.dataset.initialSort,
        page: url.searchParams.get('page')
      });
    }

    requestUrl(state) {
      var url = new URL(this.endpoint, window.location.origin);
      url.searchParams.set('sfs_endpoint', 'collection_ui');
      url.searchParams.set('sfs_collection', this.collectionHandle);
      url.searchParams.set('sort', state.sort);
      url.searchParams.set('sfs_page_size', String(this.pageSize));
      if (state.page > 1) url.searchParams.set('page', String(state.page));
      PUBLIC_GROUPS.forEach(function (group) {
        (state.filters[group] || []).forEach(function (label) {
          url.searchParams.append('sfs_' + group, label);
        });
      });
      return url;
    }

    optionRequestUrl(group, query) {
      var url = new URL(this.endpoint, window.location.origin);
      url.searchParams.set('sfs_endpoint', 'facet_options');
      url.searchParams.set('sfs_collection', this.collectionHandle);
      url.searchParams.set('sfs_group', group);
      url.searchParams.set('sfs_query', query);
      var state = normalizeState(this.desiredState || this.currentState);
      PUBLIC_GROUPS.forEach(function (candidate) {
        (state.filters[candidate] || []).forEach(function (label) {
          url.searchParams.append('sfs_' + candidate, label);
        });
      });
      return url;
    }

    visibleUrl(state) {
      var url = new URL(window.location.href);
      url.pathname = new URL(this.collectionUrl, window.location.origin).pathname;
      var mappedNative = this.nativeFilterMode(url) === 'mapped';
      Array.from(url.searchParams.keys()).forEach(function (key) {
        if (key.indexOf('sfs_') === 0 || (mappedNative && key === 'filter.p.m.breakers.poles')) {
          url.searchParams.delete(key);
        }
      });
      url.searchParams.delete('sort_by');
      url.searchParams.delete('page');
      PUBLIC_GROUPS.forEach(function (group) {
        (state.filters[group] || []).forEach(function (label) {
          url.searchParams.append('sfs_' + group, label);
        });
      });
      if (state.sort !== 'best-selling') url.searchParams.set('sort_by', state.sort);
      if (state.page > 1) url.searchParams.set('page', String(state.page));
      return url;
    }

    hasNativeFilterParams(url) {
      return Array.from(url.searchParams.keys()).some(function (key) {
        return key.indexOf('filter.') === 0;
      });
    }

    nativeFilterMode(url) {
      if (!this.hasNativeFilterParams(url)) return 'none';
      var helper = window.SFS_ACTIVE_FILTERS;
      return helper && typeof helper.parseUrl === 'function'
        ? helper.parseUrl(url).nativeMode : 'unsupported';
    }

    hasUnsupportedNativeFilters(url) {
      return this.nativeFilterMode(url) === 'unsupported';
    }

    snapshotUrlKey(url) {
      return url.pathname + url.search;
    }

    captureInitialSnapshot(state, url) {
      var grid = this.gridId ? this.querySelector('#' + this.gridId) : null;
      var pagination = this.querySelector('.collection-results-footer .pagination-holder');
      var count = this.querySelector('.collection-count');
      if (!grid || !pagination || !count) return null;
      return {
        gridChildren: importChildren(grid),
        pagination: document.importNode(pagination, true),
        countText: count.textContent,
        state: this.nativeFilterMode(url) === 'mapped' ? cloneState(state)
          : normalizeState({ filters: {}, sort: state.sort, page: state.page }),
        nativeFilterUrlKey: this.hasNativeFilterParams(url) ? this.snapshotUrlKey(url) : ''
      };
    }

    canRestoreSnapshot(state, options) {
      if (!this.initialSnapshot || !sameBaseState(state, this.initialSnapshot.state)) return false;
      var currentUrl = new URL(window.location.href);
      var currentHasNativeFilters = this.hasNativeFilterParams(currentUrl);
      if (!this.initialSnapshot.nativeFilterUrlKey && !currentHasNativeFilters) return true;
      return options.historyMode === 'none' &&
        this.initialSnapshot.nativeFilterUrlKey === this.snapshotUrlKey(currentUrl);
    }

    restoreSnapshot(state, options) {
      var grid = this.gridId ? this.querySelector('#' + this.gridId) : null;
      var pagination = this.querySelector('.collection-results-footer .pagination-holder');
      var count = this.querySelector('.collection-count');
      if (!grid || !pagination || !count || !this.initialSnapshot) return false;
      grid.replaceChildren.apply(grid, this.initialSnapshot.gridChildren.map(function (node) {
        return document.importNode(node, true);
      }));
      pagination.replaceWith(document.importNode(this.initialSnapshot.pagination, true));
      count.textContent = this.initialSnapshot.countText;
      this.currentState = state;
      this.renderedState = cloneState(state);
      this.desiredState = cloneState(state);
      this.updateHistory(state, options.historyMode);
      this.renderedUrl = window.location.href;
      this.restoreInitialAvailability();
      this.syncControls();
      this.refreshDrawer();
      this.announce(count.textContent.trim() || this.dataset.resultsUpdatedMessage);
      this.restoreFocus(options.focusLabel || '');
      if (options.scrollToGrid) this.scrollToGrid();
      if (window.SBAnalytics) window.SBAnalytics.filterCommit(options.analyticsIntent, this);
      return true;
    }

    setBusy(busy) {
      var filter = this.querySelector('filter-component');
      this.toggleAttribute('data-sfs-loading', busy);
      this.setAttribute('aria-busy', busy ? 'true' : 'false');
      if (filter) filter.setAttribute('aria-busy', busy ? 'true' : 'false');
    }

    settleBusyState() {
      if (!this.controller && !this.pendingLoad) this.setBusy(false);
    }

    announce(message) {
      if (!this.status || !message) return;
      this.status.textContent = '';
      window.setTimeout(function () {
        this.status.textContent = message;
      }.bind(this), 20);
    }

    updateHistory(state, mode) {
      if (mode === 'push') {
        window.history.pushState({ sfsCollection: true }, '', this.visibleUrl(state));
      } else if (mode === 'replace') {
        window.history.replaceState({ sfsCollection: true }, '', this.visibleUrl(state));
      }
    }

    async load(rawState, options) {
      options = options || {};
      if (this.hasUnsupportedNativeFilters(new URL(window.location.href))) return;
      var state = normalizeState(rawState);
      var previousState = this.desiredState || this.currentState;
      if (filterStateKey(previousState) !== filterStateKey(state)) {
        this.resetOptionSearches();
      }
      this.desiredState = cloneState(state);
      this.syncControls(this.desiredState);
      this.pendingLoad = { state: state, options: options };
      if (this.controller) return;
      await this.runNextLoad();
    }

    resetOptionSearches() {
      this.optionTimers.forEach(function (timer) { window.clearTimeout(timer); });
      this.optionTimers.clear();
      this.optionControllers.forEach(function (controller) { controller.abort(); });
      this.optionControllers.clear();
      this.optionPending.clear();
      this.querySelectorAll('[data-sfs-option-search]').forEach(function (input) {
        input.value = '';
        var group = input.dataset.sfsOptionSearch;
        this.filterLocalOptions(group, '');
        this.setOptionStatus(group, '');
      }.bind(this));
    }

    async runNextLoad() {
      if (this.controller || !this.pendingLoad) return;
      var job = this.pendingLoad;
      this.pendingLoad = null;
      var state = job.state;
      var options = job.options || {};
      var fallback = window.SFSNativeFallback;
      if (fallback && fallback.enabled() && fallback.shouldSkipCollectionEngine(this, state)) {
        var nativeController = new AbortController();
        this.controller = nativeController;
        try { await fallback.serveCollectionWithoutEngine(this, state, options); }
        finally { if (this.controller === nativeController) this.controller = null; }
        if (this.pendingLoad) await this.runNextLoad();
        this.settleBusyState();
        return;
      }
      if (!(fallback && fallback.enabled() && fallback.readSource({ q: '', collection: this.collectionHandle }) === 'engine') && this.canRestoreSnapshot(state, options) && this.restoreSnapshot(state, options)) {
        if (this.pendingLoad) await this.runNextLoad();
        this.settleBusyState();
        return;
      }
      var controller = new AbortController();
      this.controller = controller;
      var timedOut = false;
      var timeout = fallback && fallback.enabled() ? null : window.setTimeout(function () {
        timedOut = true;
        controller.abort();
      }, RESULT_TIMEOUT_MS);
      this.setBusy(true);

      try {
        var html;
        if (fallback && fallback.enabled()) {
          html = await fallback.fetchBudget(this.requestUrl(state).toString(), window.SFS_NATIVE_FALLBACK.timeoutMs, controller.signal, 'collection');
        } else {
        var response = await fetch(this.requestUrl(state).toString(), {
          method: 'GET',
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { Accept: 'text/html' },
          signal: controller.signal
        });
        if (!response.ok) throw new Error('collection endpoint returned ' + response.status);
        html = await response.text();
        }
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var source = parsed.querySelector('[data-sfs-collection-response]');
        if (!source || source.dataset.collectionHandle !== this.collectionHandle) {
          throw Object.assign(new Error('invalid collection response'), { sfsReason: 'invalid_payload' });
        }
        if (stateKey(state) !== stateKey(this.desiredState)) return;
        if (fallback && fallback.enabled()) {
          var verdict = fallback.inspectCollectionResponse(source, state);
          if (verdict.reason === 'engine_zero') {
            fallback.record('engine_zero', { surface: 'collection' });
            await fallback.serveCollectionWithoutEngine(this, state, Object.assign({}, options, { previousSource: 'engine' }));
            return;
          }
          if (verdict.reason) throw Object.assign(new Error('invalid collection response'), { sfsReason: verdict.reason });
        }
        var availability = this.availabilityFromFragment(source);
        var countText = this.commitFragment(source);
        if (availability) this.applyAvailability(availability, state, { committed: true });
        this.currentState = state;
        this.renderedState = cloneState(state);
        this.desiredState = cloneState(state);
        this.updateHistory(state, options.historyMode);
        this.renderedUrl = window.location.href;
        this.syncControls();
        this.refreshDrawer();
        this.announce(countText || this.dataset.resultsUpdatedMessage);
        this.restoreFocus(options.focusLabel || '');
        if (options.scrollToGrid) this.scrollToGrid();
        if (window.SBAnalytics) window.SBAnalytics.filterCommit(options.analyticsIntent, this);
        if (fallback && fallback.enabled()) fallback.rememberSource('engine', {
          q: '', collection: this.collectionHandle, page: state.page, sort: state.sort, filters: state.filters
        });
      } catch (error) {
        if (fallback && fallback.enabled() && stateKey(state) === stateKey(this.desiredState) &&
            (timedOut || error.name !== 'AbortError')) {
          var reason = timedOut ? 'timeout' : fallback.classifyEngineError(error);
          await fallback.recoverCollectionFailure(this, state, options, reason);
          return;
        }
        if (stateKey(state) === stateKey(this.desiredState) &&
            (timedOut || error.name !== 'AbortError')) {
          this.currentState = cloneState(this.renderedState || this.currentState);
          this.desiredState = cloneState(this.currentState);
          // A deep link or Back/Forward may never have loaded, and a queued
          // click can fail in push mode while the URL still names an earlier,
          // never-committed target. Every failure path replaces the URL so
          // it always matches the grid actually on screen.
          if (this.renderedUrl) {
            window.history.replaceState({ sfsCollection: true }, '', this.renderedUrl);
          } else this.updateHistory(this.currentState, 'replace');
          this.syncControls(this.currentState);
          this.announce(this.dataset.errorMessage || 'Filters are temporarily unavailable.');
        }
      } finally {
        window.clearTimeout(timeout);
        if (this.controller === controller) this.controller = null;
        if (this.pendingLoad) await this.runNextLoad();
        this.settleBusyState();
      }
    }

    availabilityFromFragment(source) {
      var node = source.querySelector('[data-sfs-collection-availability]');
      // An origin that does not publish the availability contract still
      // returns a usable grid. Commit that grid and leave the rail alone.
      if (!node) return null;
      var payload;
      try {
        payload = JSON.parse(node.getAttribute('data-sfs-collection-availability') || '');
      } catch (error) {
        throw new Error('invalid collection availability');
      }
      if (!payload || payload.version !== 1 || !payload.groups ||
          typeof payload.groups !== 'object' || Array.isArray(payload.groups)) {
        throw new Error('invalid collection availability');
      }
      return payload;
    }

    // Builds (once) the full block for every engine-returned group that has
    // no block yet -- bootstrap-rendered groups are always skipped by the
    // existingBlock check, so this only ever ADDS a group bootstrap could
    // not have known about, never touches one bootstrap already rendered.
    // New blocks are inserted in the engine's own group order (see
    // orderedAvailabilityGroupKeys) relative to whichever sibling blocks --
    // bootstrap or already-dynamic -- also appear in THIS SAME payload,
    // never appended blindly to the end.
    materializeMissingGroupBlocks(payload) {
      // Lazily created rather than only in connectedCallback: several
      // existing unit-test harnesses instantiate this class directly and
      // exercise applyAvailability without ever running connectedCallback,
      // and this method's early returns below (no rail container yet)
      // must not skip creating it before the caller's own dynamicGroups
      // read.
      if (!this.dynamicGroups) this.dynamicGroups = new Set();
      var container = this.querySelector('[data-sfs-filter-rail] .filter-section');
      if (!container) return;
      var engineKeys = orderedAvailabilityGroupKeys(payload);
      // Only breaker collection rails opt into this display order. Keep the
      // engine order for every other rail and for unranked breaker groups.
      var preferredKeys = String(container.getAttribute('data-sfs-group-order') || '').split(',').filter(function (group) {
        return PUBLIC_GROUP_SET.has(group);
      });
      var allKeys = preferredKeys.concat(engineKeys.filter(function (group) {
        return preferredKeys.indexOf(group) === -1;
      }));
      var orderedKeys = allKeys.filter(function (group) { return engineKeys.indexOf(group) !== -1; });
      var orderIndex = {};
      allKeys.forEach(function (group, index) { orderIndex[group] = index; });

      orderedKeys.forEach(function (group) {
        if (container.querySelector('[data-sfs-group="' + group + '"]')) return;
        var labels = [];
        payload.groups[group].forEach(function (rawLabel) {
          var label = cleanLabel(rawLabel);
          if (label && labels.indexOf(label) === -1) labels.push(label);
        });
        // Nothing usable yet (every raw label failed cleanLabel) -- wait
        // for a later payload rather than building an empty block.
        if (!labels.length) return;
        var block = this.buildGroupBlock(group, labels);
        if (!block) return;
        // Direct children only, never querySelectorAll('[data-sfs-group]')
        // -- every row's own filter-link anchor also carries a
        // data-sfs-group attribute (see buildInitialFilterRow), so a
        // descendant query would return hundreds of nested anchors here
        // too and insertAdjacentElement could land the new block inside a
        // stranger's row list instead of beside it as an actual sibling.
        var siblings = Array.prototype.filter.call(container.children, function (child) {
          return child.hasAttribute && child.hasAttribute('data-sfs-group');
        });
        var anchor = siblings.find(function (candidate) {
          var candidateGroup = candidate.getAttribute('data-sfs-group');
          return orderIndex.hasOwnProperty(candidateGroup) && orderIndex[candidateGroup] > orderIndex[group];
        });
        if (anchor) anchor.insertAdjacentElement('beforebegin', block);
        else container.appendChild(block);
        this.dynamicGroups.add(group);
      }.bind(this));
    }

    // A block built here must be indistinguishable from one Liquid
    // rendered: same accordion-component/details/summary shape, same
    // filter-block/filter-type-list/select-none classes plus the slug
    // class, same data-sfs-group and jsFilterUpdate wiring. It opens by
    // default -- unlike a bootstrap block past the third position -- since
    // it only ever appears in direct response to something the shopper
    // just chose, so it should be immediately visible, not one more click
    // away. data-sfs-dynamic-group is the one addition, an internal marker
    // (see applyAvailability and restoreInitialAvailability) invisible to
    // the shopper, never a visual or behavioural difference.
    buildGroupBlock(group, labels) {
      var groupLabelText = humanizeGroupSlug(group);
      var block = document.createElement('accordion-component');
      block.className = 'filter-block filter-type-list select-none ' + group;
      block.setAttribute('data-sfs-group', group);
      block.setAttribute('data-sfs-dynamic-group', '');

      var details = document.createElement('details');
      details.open = true;
      var summary = document.createElement('summary');
      summary.className = 'c-pointer';
      var labelSpan = document.createElement('span');
      labelSpan.className = 'label';
      labelSpan.textContent = groupLabelText;
      var expandSpan = document.createElement('span');
      expandSpan.className = 'expand';
      var arrowIcon = this.cloneIcon('[data-sfs-group] .expand svg');
      if (arrowIcon) expandSpan.appendChild(arrowIcon);
      summary.appendChild(labelSpan);
      summary.appendChild(expandSpan);

      var wrapper = document.createElement('div');
      wrapper.className = 'filter-section-wrapper jsFilterUpdate';
      wrapper.setAttribute('data-filter-id', group);

      var headLabels = labels.slice(0, MAX_VALUES_PER_GROUP);
      var tailLabels = labels.slice(MAX_VALUES_PER_GROUP);
      var wantsSearch = (headLabels.length >= 8 && OPTION_SEARCH_GROUP_SET.has(group)) ||
        labels.length > MAX_VALUES_PER_GROUP;
      if (wantsSearch) wrapper.appendChild(this.buildOptionSearchControl(group, groupLabelText));

      var list = document.createElement('ul');
      list.className = 'filter-section-list';
      list.setAttribute('role', 'list');
      list.setAttribute('data-sfs-option-list', group);
      headLabels.forEach(function (label) {
        list.appendChild(this.buildInitialFilterRow(group, label, groupLabelText));
      }.bind(this));
      wrapper.appendChild(list);

      if (tailLabels.length) {
        var script = document.createElement('script');
        script.type = 'application/json';
        script.setAttribute('data-sfs-more-options', group);
        script.textContent = JSON.stringify(tailLabels);
        wrapper.appendChild(script);

        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'link highlight sfs-show-more';
        button.setAttribute('data-sfs-show-more', group);
        button.setAttribute('aria-expanded', 'false');
        button.textContent = 'Show ' + tailLabels.length + ' more';
        wrapper.appendChild(button);
      }

      details.appendChild(summary);
      details.appendChild(wrapper);
      block.appendChild(details);
      return block;
    }

    // Matches a Liquid-rendered <li> byte for byte in shape: same classes,
    // same hidden/disabled checkbox wired to a real label for the same
    // checked-state and screen-reader semantics, same link-overlay anchor
    // carrying every data-sfs-filter-link attribute the click handler and
    // syncControls already expect. syncControls overwrites href/aria-label/
    // checked state on the very next call (see runNextLoad), so the values
    // set here only have to be valid, not final.
    buildInitialFilterRow(group, label, groupLabelText) {
      var row = document.createElement('li');
      row.className = 'filter-section-list-item relative jsFilterToggle';
      row.setAttribute('data-sfs-filter-item', '');
      row.setAttribute('data-sfs-initial-option', '');

      var input = document.createElement('input');
      input.type = 'checkbox';
      this.dynamicOptionCount += 1;
      var id = 'sfsDynamic-' + this.instanceId + '-' + this.dynamicOptionCount;
      input.id = id;
      input.className = 'input-hidden filter-input';
      input.tabIndex = -1;
      input.setAttribute('aria-hidden', 'true');
      input.disabled = true;

      var rowLabel = document.createElement('label');
      rowLabel.setAttribute('for', id);
      rowLabel.className = 'c-pointer checkbox flex flex-gap';

      var stateDefault = document.createElement('span');
      stateDefault.className = 'input-state-default';
      var checkboxIcon = this.cloneIcon('[data-sfs-group] .input-state-default svg');
      if (checkboxIcon) stateDefault.appendChild(checkboxIcon);

      var stateActive = document.createElement('span');
      stateActive.className = 'input-state-active';
      var checkedIcon = this.cloneIcon('[data-sfs-group] .input-state-active svg');
      if (checkedIcon) stateActive.appendChild(checkedIcon);

      var text = document.createElement('span');
      text.className = 'text';
      text.textContent = label;

      rowLabel.appendChild(stateDefault);
      rowLabel.appendChild(stateActive);
      rowLabel.appendChild(text);

      var link = document.createElement('a');
      link.className = 'link-overlay';
      link.setAttribute('data-sfs-filter-link', '');
      link.setAttribute('data-sfs-group', group);
      link.setAttribute('data-sfs-group-label', groupLabelText);
      link.setAttribute('data-sfs-label', label);
      link.setAttribute('aria-label', 'Add ' + groupLabelText + ' ' + label);
      // syncControls (called right after, in every real load path) replaces
      // this with visibleUrl()'s full toggle URL -- this only has to be a
      // valid string in the meantime, including in a harness that never
      // set collectionUrl.
      link.href = (this.collectionUrl || '') + '?sfs_' + encodeURIComponent(group) + '=' + encodeURIComponent(label);

      row.appendChild(input);
      row.appendChild(rowLabel);
      row.appendChild(link);
      return row;
    }

    // Only reachable for a group with more raw labels than fit in the head
    // (>12) or, matching the identical Liquid heuristic, a brand/series
    // group with 8+. No backend exists to remote-search a brand-new engine
    // group either way -- onOptionSearch already gates the fetch itself
    // behind OPTION_SEARCH_GROUP_SET, so this control still degrades to the
    // same local-only filtering every non-brand/series group already uses.
    buildOptionSearchControl(group, groupLabelText) {
      var searchLabelText = 'Search ' + groupLabelText;
      var wrap = document.createElement('div');
      wrap.className = 'sfs-option-search js';

      var statusId = 'sfsOptionStatus-' + this.instanceId + '-' + group;
      var inputId = 'sfsOptionSearch-' + this.instanceId + '-' + group;

      var label = document.createElement('label');
      label.className = 'sfs-option-search__label';
      label.setAttribute('for', inputId);
      label.textContent = searchLabelText;

      var relative = document.createElement('div');
      relative.className = 'relative';

      var input = document.createElement('input');
      input.type = 'search';
      input.id = inputId;
      input.className = 'input-field sfs-option-search__input';
      input.setAttribute('aria-describedby', statusId);
      input.placeholder = searchLabelText;
      input.setAttribute('data-sfs-option-search', group);
      input.autocomplete = 'off';

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'btn-filter-search absolute r0 t0 h100 c-pointer';
      button.setAttribute('aria-label', searchLabelText);
      button.setAttribute('data-sfs-option-search-focus', '');
      var searchIcon = this.cloneIcon('.btn-filter-search svg');
      if (searchIcon) button.appendChild(searchIcon);

      relative.appendChild(input);
      relative.appendChild(button);

      var status = document.createElement('p');
      status.id = statusId;
      status.className = 'sfs-option-search__status';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.setAttribute('aria-atomic', 'true');
      status.setAttribute('data-sfs-option-status', group);

      wrap.appendChild(label);
      wrap.appendChild(relative);
      wrap.appendChild(status);
      return wrap;
    }

    // Reuses whatever icon markup Liquid already rendered elsewhere in this
    // rail instead of hand-duplicating raw SVG path data that would then
    // silently drift from snippets/svg.liquid. Returns null (never throws)
    // when no such icon exists yet -- for example a rail made only of
    // native Shopify filters -- so a caller can skip the decorative icon
    // without losing the row or control it decorates.
    cloneIcon(selector) {
      var node = this.querySelector(selector);
      return node ? node.cloneNode(true) : null;
    }

    // Card count in the committed grid plus whether pagination offers
    // another page. The availability payload is version + groups only, and
    // .collection-count is translated prose, so neither is a numeric total.
    committedResultCountAtMostOne() {
      var grid = this.gridId ? this.querySelector('#' + this.gridId) : null;
      var pagination = this.querySelector('.collection-results-footer .pagination-holder');
      if (!grid || !pagination) return false;
      var cardCount = grid.querySelectorAll('.product-card').length;
      var hasNextPage = !!(
        pagination.querySelector('[rel="next"]') ||
        pagination.querySelector('infinite-loading')
      );
      return cardCount <= 1 && !hasNextPage;
    }

    applyAvailability(payload, rawState, options) {
      var state = normalizeState(rawState);
      var partial = !!(options && options.partial);
      var committed = !!(options && options.committed);
      var requestInFlight = !!(this.controller || this.pendingLoad);
      // Hide unselected groups only after a committed response whose
      // observed result set cannot shrink further. Partial first paint has
      // not seen a count; an in-flight request has not committed yet.
      var cannotNarrow = !partial && (committed || !requestInFlight) &&
        this.committedResultCountAtMostOne();
      // A group the engine returns that bootstrap never rendered (e.g.
      // aic_min, only unlocked once a Rated Voltage is selected) has no
      // block or option list to update -- it must be built first, in the
      // engine's own group order, before the per-group loop below can do
      // anything with it. Materializing is a strict no-op for every group
      // that already has a block, bootstrap-rendered or not.
      this.materializeMissingGroupBlocks(payload);
      PUBLIC_GROUPS.forEach(function (group) {
        var source = payload.groups[group];
        // Two different statements share an omitted key and must not be
        // collapsed into one:
        // - A complete engine payload that does not mention this group
        //   means zero values remain selectable. Treat that as [] for
        //   every group, bootstrap or dynamic -- the hidden-unless-selected
        //   rule below is what keeps a selected value reachable.
        // - A PARTIAL payload (first paint from the URL's own selections)
        //   names only the groups it knows about. An omitted key there
        //   means unknown, so this group is left exactly as last rendered.
        if (!Array.isArray(source)) {
          if (partial) return;
          source = [];
        }
        var selectedValues = state.filters[group] || [];
        var availableLabels = new Set();
        if (selectedValues.length) {
          // Selections inside one group are OR'd; across groups they are
          // AND'd. Once this group holds a selection, the current result
          // set can only contain those selected values -- never FA next to
          // a selected EDB, never Eaton next to a selected Square D.
          selectedValues.forEach(function (value) {
            var label = cleanLabel(value);
            if (label) availableLabels.add(label);
          });
        } else {
          source.forEach(function (rawLabel) {
            var label = cleanLabel(rawLabel);
            if (label) availableLabels.add(label);
          });
        }
        this.availableOptions.set(group, availableLabels);
        var list = this.querySelector('[data-sfs-option-list="' + group + '"]');
        if (!list) return;
        var normalizedQuery = this.currentOptionQuery(group);
        list.querySelectorAll('[data-sfs-filter-item]').forEach(function (row) {
          var link = row.querySelector('[data-sfs-filter-link]');
          var label = cleanLabel(link && link.dataset.sfsLabel);
          var selected = !!(state.filters[group] &&
            state.filters[group].indexOf(label) >= 0);
          var unavailable = !selected && !availableLabels.has(label);
          row.toggleAttribute('data-sfs-unavailable', unavailable);
          syncRowHidden(row, normalizedQuery);
        });
        // G3: a value's position in the raw bootstrap list has no
        // relationship to whether it is buyable under the CURRENT filters.
        // Without this, the visible head can end up entirely
        // data-sfs-unavailable while every real option for this query sits
        // unrendered in the Show-more tail.
        this.reconcileHeadSelectability(group, list, availableLabels, selectedValues, normalizedQuery);
        var block = list.closest('[data-sfs-group]');
        if (block) {
          // Availability alone decides the group block. A text search that
          // matches nothing must never hide its own search input.
          // Valid choices may still be in the embedded Show more JSON.
          // Fewer than two selectable options leaves nothing meaningful to
          // choose between, so the block hides -- UNLESS it already holds a
          // selected value, which must never be stranded behind a hidden
          // group, even at exactly one remaining option. One committed
          // result (or fewer) is the same: no unselected group can narrow
          // the set, but a selected group stays so the shopper can untick.
          if (!partial) {
            var guideHidden = Array.isArray(payload.guide_hidden_groups) &&
              payload.guide_hidden_groups.indexOf(group) >= 0;
            block.toggleAttribute('data-sfs-guide-redundant', guideHidden);
          }
          var hasSelection = !!selectedValues.length;
          block.hidden = !hasSelection && (availableLabels.size < 2 || cannotNarrow);
        }
        var searchInput = this.querySelector('[data-sfs-option-search="' + group + '"]');
        if (searchInput) {
          var searchWrap = searchInput.closest('.sfs-option-search');
          if (searchWrap) searchWrap.hidden = !!selectedValues.length;
        }
        // The disclosure control's count must track what actually survives
        // this availability payload, never the raw tail length from first
        // paint -- otherwise "Show N more" can promise values that only
        // ever render hidden once promoted.
        this.syncEmbeddedOptions(group, list, normalizedQuery);
      }.bind(this));
    }

    // A group's first GROUP_HEAD_SIZE rows are the ones Liquid rendered as
    // data-sfs-initial-option, plus any this method has already promoted
    // (data-sfs-promoted-option). Neither position in the engine's raw
    // list, nor an earlier promotion, is a promise that a value is buyable
    // under the CURRENT filters -- only the last availability payload knows
    // that. When too few of the visible head remain selectable (available,
    // or already chosen), this pulls selectable values out of the
    // Show-more tail, in the tail's own order, to fill the gap; the tail is
    // exactly the engine's natural sort continued past the twelfth entry,
    // so a value pulled from its front is never out of order relative to
    // whatever survives in the head. When availability widens again and the
    // head no longer needs an earlier promotion, this releases the excess
    // ones first so the visible count settles back toward GROUP_HEAD_SIZE
    // instead of only ever growing. Released and unpromoted rows are
    // hidden, never removed -- the same reversibility already used for the
    // Show-more control itself.
    reconcileHeadSelectability(group, list, availableLabels, selectedValues, normalizedQuery) {
      var headRows = Array.prototype.filter.call(
        list.querySelectorAll('[data-sfs-filter-item]'),
        function (row) {
          return row.hasAttribute('data-sfs-initial-option') || row.hasAttribute('data-sfs-promoted-option');
        }
      );
      var isSelectable = function (row) {
        var link = row.querySelector('[data-sfs-filter-link]');
        var label = cleanLabel(link && link.dataset.sfsLabel);
        return availableLabels.has(label) || selectedValues.indexOf(label) !== -1;
      };
      var selectableHeadRows = headRows.filter(isSelectable);

      if (selectableHeadRows.length > GROUP_HEAD_SIZE) {
        var excess = selectableHeadRows.length - GROUP_HEAD_SIZE;
        for (var i = selectableHeadRows.length - 1; i >= 0 && excess > 0; i -= 1) {
          var candidate = selectableHeadRows[i];
          if (!candidate.hasAttribute('data-sfs-promoted-option')) continue;
          candidate.hidden = true;
          excess -= 1;
        }
        return;
      }

      var deficit = GROUP_HEAD_SIZE - selectableHeadRows.length;
      if (deficit <= 0) return;

      var scriptNode = this.querySelector('[data-sfs-more-options="' + group + '"]');
      if (!scriptNode) return;
      var tailLabels;
      try {
        tailLabels = JSON.parse(scriptNode.textContent || '[]');
      } catch (error) {
        return;
      }
      if (!Array.isArray(tailLabels)) return;

      var renderedLabels = Array.prototype.map.call(
        list.querySelectorAll('[data-sfs-filter-link]'),
        function (link) { return link.dataset.sfsLabel; }
      );

      for (var index = 0; index < tailLabels.length && deficit > 0; index += 1) {
        var label = cleanLabel(tailLabels[index]);
        if (!label || renderedLabels.indexOf(label) !== -1) continue;
        if (!availableLabels.has(label) && selectedValues.indexOf(label) === -1) continue;
        var row = this.ensureOptionRow(group, label, false);
        if (!row) continue;
        if (!row.hasAttribute('data-sfs-initial-option') && !row.hasAttribute('data-sfs-expanded-option')) {
          row.setAttribute('data-sfs-promoted-option', '');
        }
        syncRowHidden(row, normalizedQuery);
        renderedLabels.push(label);
        deficit -= 1;
      }
    }

    restoreInitialAvailability() {
      this.availableOptions.clear();
      this.querySelectorAll(
        '[data-sfs-filter-item][data-sfs-initial-option], [data-sfs-filter-item][data-sfs-expanded-option]'
      ).forEach(function (row) {
        row.removeAttribute('data-sfs-unavailable');
        var group = row.closest('[data-sfs-option-list]');
        syncRowHidden(row, this.currentOptionQuery(
          group ? group.dataset.sfsOptionList : ''
        ));
      }.bind(this));
      this.querySelectorAll('[data-sfs-group]').forEach(function (block) {
        // A dynamically materialized group never existed in the true
        // server-rendered initial state -- its rows carry
        // data-sfs-initial-option (see buildInitialFilterRow) for the same
        // reconciliation reasons a bootstrap row does, but that marker must
        // not make this restore path resurrect a block bootstrap itself
        // never produced. canRestoreSnapshot only reaches this method when
        // the target state's full filter set matches the page's true
        // initial snapshot, so a dynamic group's block is always correct to
        // force back to hidden here, with no selected-value exception to
        // preserve -- a matching snapshot state cannot hold a selection in a
        // group that group only ever existed because of a filter that
        // snapshot itself excludes.
        if (block.hasAttribute('data-sfs-dynamic-group')) {
          block.hidden = true;
          return;
        }
        if (block.querySelector(
          '[data-sfs-filter-item][data-sfs-initial-option], [data-sfs-filter-item][data-sfs-expanded-option]'
        )) {
          block.hidden = false;
        }
      });
      this.querySelectorAll('.sfs-option-search').forEach(function (wrap) {
        wrap.hidden = false;
      });
    }

    commitFragment(source) {
      var gridTarget = this.gridId ? this.querySelector('#' + this.gridId) : null;
      var paginationTarget = this.querySelector('.collection-results-footer .pagination-holder');
      var countTarget = this.querySelector('.collection-count');
      var gridSource = source.querySelector('[data-sfs-collection-grid]');
      var paginationSource = source.querySelector('[data-sfs-collection-pagination] .pagination-holder');
      var countSource = source.querySelector('[data-sfs-collection-count-text]');
      if (!gridTarget || !paginationTarget || !countTarget ||
          !gridSource || !paginationSource || !countSource) {
        throw new Error('incomplete collection response');
      }
      this.normalizeCardImages(gridSource);
      this.normalizeCardLabels(gridSource);
      this.normalizeCardHeadings(gridSource);
      gridTarget.replaceChildren.apply(gridTarget, importChildren(gridSource));
      paginationTarget.replaceWith(document.importNode(paginationSource, true));
      countTarget.textContent = countSource.textContent.trim();
      return countTarget.textContent.trim();
    }

    normalizeCardHeadings(grid) {
      grid.querySelectorAll('h3.product-card-title-heading, h5.product-card-title-heading').forEach(function (heading) {
        var replacement = document.createElement('h2');
        Array.prototype.forEach.call(heading.attributes, function (attribute) {
          replacement.setAttribute(attribute.name, attribute.value);
        });
        while (heading.firstChild) replacement.appendChild(heading.firstChild);
        heading.replaceWith(replacement);
      });
    }

    normalizeCardImages(grid) {
      var fallback = this.dataset.defaultImage;
      if (!fallback) return;
      grid.querySelectorAll('.image__style').forEach(function (media) {
        if (media.children.length || media.textContent.trim()) return;
        var image = document.createElement('img');
        image.src = fallback;
        image.alt = 'Image coming soon';
        image.loading = 'lazy';
        image.width = 375;
        image.height = 375;
        media.appendChild(image);
      });
    }

    normalizeCardLabels(grid) {
      var labels = this.dataset;
      function span(className, text, hidden) {
        var node = document.createElement('span');
        node.className = className;
        node.textContent = text;
        if (hidden) node.setAttribute('aria-hidden', 'true');
        return node;
      }
      grid.querySelectorAll('.product-card--variant-title > a').forEach(function (link) {
        if (link.querySelector('.product-card--condition-label')) return;
        var raw = link.textContent.trim().toLowerCase();
        var recert = /^(re-certified|recertified|recert)$/.test(raw);
        if (!recert && raw !== 'new') return;
        var full = recert ? labels.labelRecertified : labels.labelNew;
        var compact = recert ? labels.labelRecertifiedShort : labels.labelNew;
        if (!full || !compact) return;
        link.setAttribute('aria-label', full);
        link.replaceChildren(
          span('product-card--condition-label product-card--condition-label--full', full),
          span('product-card--condition-label product-card--condition-label--compact', compact, true)
        );
      });
      grid.querySelectorAll('.label-inner').forEach(function (stock) {
        var full = stock.querySelector('.product-card--stock-label');
        if (!full) return;
        var text = stock.classList.contains('label-in_stock') ? labels.labelInStock
          : stock.classList.contains('label-low_stock') ? labels.labelLowStock
          : stock.classList.contains('label-out_stock') ? labels.labelNoStock : '';
        if (!text) return;
        full.textContent = text;
        full.classList.add('product-card--stock-label--full');
        var compact = stock.querySelector('.product-card--stock-label-compact');
        if (compact) compact.textContent = text;
        else stock.appendChild(span('product-card--stock-label-compact', text, true));
      });
    }

    refreshDrawer() {
      var filter = this.querySelector('filter-component');
      if (filter && filter.popStateBound && filter.onPopState) {
        window.removeEventListener('popstate', filter.onPopState);
        filter.popStateBound = false;
      }
      if (filter && typeof filter.refreshDrawerElements === 'function') {
        filter.refreshDrawerElements();
      }
      if (filter && typeof filter.syncDrawerAccessibility === 'function') {
        filter.syncDrawerAccessibility(false);
      }
    }

    onClick(event) {
      var sortLabel = event.target.closest('.sort-section label');
      var sortInput = event.target.closest('.sort-section input[type="radio"]') || (sortLabel && sortLabel.control);
      if (sortInput && this.contains(sortInput)) {
        // Selecting the current option does not dispatch a change event.
        if (sortInput.checked) this.closeSortDropdown(sortInput, true);
        return;
      }

      var nativeLink = event.target.closest('[data-sfs-native-link]');
      if (nativeLink && this.contains(nativeLink)) {
        // Keep browser link behavior (including new tabs), but do not let
        // the legacy AJAX filter owner rebuild these native Shopify URLs.
        event.stopPropagation();
        return;
      }
      // Unsupported URLs retain native link ownership, including recovery links.
      if (this.hasUnsupportedNativeFilters(new URL(window.location.href))) return;

      var searchButton = event.target.closest('[data-sfs-option-search-focus]');
      if (searchButton && this.contains(searchButton)) {
        event.preventDefault();
        event.stopPropagation();
        var searchInput = searchButton.parentElement.querySelector('[data-sfs-option-search]');
        if (searchInput) searchInput.focus();
        return;
      }

      var showMoreButton = event.target.closest('[data-sfs-show-more]');
      if (showMoreButton && this.contains(showMoreButton)) {
        event.preventDefault();
        event.stopPropagation();
        this.expandMoreOptions(showMoreButton.dataset.sfsShowMore);
        return;
      }

      var clearButton = event.target.closest('[data-sfs-clear-filters]');
      if (clearButton && this.contains(clearButton)) {
        event.preventDefault();
        event.stopPropagation();
        var clearState = cloneState(this.desiredState || this.currentState);
        clearState.filters = {};
        clearState.page = 1;
        this.load(clearState, {
          analyticsIntent: window.SBAnalytics && window.SBAnalytics.filterIntent(clearButton),
          historyMode: 'push',
          focusLabel: '',
          scrollToGrid: true
        });
        return;
      }

      var removeChip = event.target.closest('[data-sfs-remove-filter]');
      if (removeChip && this.contains(removeChip)) {
        var removeGroup = removeChip.dataset.sfsGroup;
        var removeLabel = cleanLabel(removeChip.dataset.sfsLabel);
        if (!PUBLIC_GROUP_SET.has(removeGroup) || !removeLabel) return;
        event.preventDefault();
        event.stopPropagation();
        // Chips are remove-only, never a toggle: a second click on a value
        // already dropped from desiredState (a stale/duplicate click queued
        // before the chip's own removal re-render lands) must stay a no-op,
        // not flip the filter back on the way stateWithSpecificToggle would.
        this.load(this.stateWithFilterRemoved(this.desiredState || this.currentState, removeGroup, removeLabel), {
          analyticsIntent: window.SBAnalytics && window.SBAnalytics.filterIntent(removeChip),
          historyMode: 'push',
          focusLabel: '',
          scrollToGrid: true
        });
        return;
      }

      var filterLink = event.target.closest('[data-sfs-filter-link]');
      if (filterLink && this.contains(filterLink)) {
        var group = filterLink.dataset.sfsGroup;
        var label = cleanLabel(filterLink.dataset.sfsLabel);
        if (!PUBLIC_GROUP_SET.has(group) || !label) return;
        event.preventDefault();
        event.stopPropagation();
        this.load(this.stateWithSpecificToggle(this.desiredState || this.currentState, group, label), {
          analyticsIntent: window.SBAnalytics && window.SBAnalytics.filterIntent(filterLink),
          historyMode: 'push',
          focusLabel: label,
          scrollToGrid: true
        });
        return;
      }

      var paginationLink = event.target.closest('.collection-results-footer .pagination-holder a[href]');
      if (!paginationLink || !this.contains(paginationLink)) return;
      if (this.hasUnsupportedNativeFilters(new URL(window.location.href))) return;
      var url;
      try {
        url = new URL(paginationLink.href, window.location.origin);
      } catch (error) {
        return;
      }
      if (url.pathname !== new URL(this.collectionUrl, window.location.origin).pathname) return;
      event.preventDefault();
      event.stopPropagation();
      var paginationState = cloneState(this.desiredState || this.currentState);
      paginationState.page = pageNumber(url.searchParams.get('page'));
      this.load(paginationState, {
        historyMode: 'push',
        focusLabel: paginationLink.getAttribute('title') || paginationLink.textContent.trim(),
        scrollToGrid: true
      });
    }

    onChange(event) {
      var input = event.target.closest('.sort-section input[type="radio"]');
      if (!input || !this.contains(input) || !SORTS.has(input.value)) return;
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      // The result swap preserves this control, so dismiss it before loading.
      var dropdown = this.closeSortDropdown(input, true);
      var currentUrl = new URL(window.location.href);
      if (this.hasUnsupportedNativeFilters(currentUrl)) {
        if (input.value === 'best-selling') currentUrl.searchParams.delete('sort_by');
        else currentUrl.searchParams.set('sort_by', input.value);
        currentUrl.searchParams.delete('page');
        window.location.assign(currentUrl.toString());
        return;
      }
      var state = cloneState(this.desiredState || this.currentState);
      state.sort = input.value;
      state.page = 1;
      this.load(state, { historyMode: 'push', focusLabel: dropdown ? '' : input.value });
    }

    closeSortDropdown(target, restoreFocus) {
      var details = target.closest('.sort-section details');
      var summary = details && details.querySelector(':scope > summary.sort-section-dropdown');
      // The mobile drawer uses an inline accordion, not a dropdown.
      if (!summary || !this.contains(details)) return false;
      details.open = false;
      if (restoreFocus) summary.focus({ preventScroll: true });
      return true;
    }

    onSortOutsideClick(event) {
      this.querySelectorAll('.sort-section details[open]').forEach(function (details) {
        if (!details.contains(event.target)) this.closeSortDropdown(details, false);
      }.bind(this));
    }

    onSortKeydown(event) {
      if (event.key !== 'Escape') return;
      var details = event.target.closest('.sort-section details[open]');
      if (!details || !this.closeSortDropdown(details, true)) return;
      event.preventDefault();
      event.stopPropagation();
    }

    onOptionSearch(event) {
      var input = event.target.closest('[data-sfs-option-search]');
      if (!input || !this.contains(input)) return;
      var group = input.dataset.sfsOptionSearch;
      if (!PUBLIC_GROUP_SET.has(group)) return;
      var query = input.value.trim().slice(0, 40);
      this.filterLocalOptions(group, query);
      if (window.SFSNativeFallback && window.SFSNativeFallback.enabled() &&
          window.SFSNativeFallback.shouldSkipCollectionEngine(this, this.desiredState)) {
        this.setOptionStatus(group, 'Select a visible filter value.');
        return;
      }
      if (!OPTION_SEARCH_GROUP_SET.has(group)) return;
      if (this.optionTimers.has(group)) window.clearTimeout(this.optionTimers.get(group));
      if (normalizedSearchText(query).length < 2) {
        this.optionPending.delete(group);
        this.setOptionStatus(group, '');
        return;
      }
      this.optionTimers.set(group, window.setTimeout(function () {
        this.loadOptions(group, query);
      }.bind(this), OPTION_SEARCH_DELAY_MS));
    }

    async loadOptions(group, query) {
      if (!OPTION_SEARCH_GROUP_SET.has(group)) return;
      if (window.SFSNativeFallback && window.SFSNativeFallback.enabled() &&
          window.SFSNativeFallback.shouldSkipCollectionEngine(this, this.desiredState)) return;
      var normalizedQuery = normalizedSearchText(query);
      if (normalizedQuery.length < 2) return;
      var cacheKey = group + ':' + normalizedQuery + ':' +
        optionContextKey(group, this.desiredState || this.currentState);
      var cached = this.optionCache.get(cacheKey);
      if (cached && cached.expiresAt > Date.now()) {
        this.optionCache.delete(cacheKey);
        this.optionCache.set(cacheKey, cached);
        this.applyOptionResults(group, cached.labels, query);
        return;
      }
      if (cached) this.optionCache.delete(cacheKey);
      if (this.optionControllers.has(group)) {
        this.optionPending.set(group, query);
        return;
      }

      var controller = new AbortController();
      var sequence = (this.optionSequences.get(group) || 0) + 1;
      var timedOut = false;
      var timeout = window.setTimeout(function () {
        timedOut = true;
        controller.abort();
      }, OPTION_TIMEOUT_MS);
      this.optionSequences.set(group, sequence);
      this.optionControllers.set(group, controller);
      this.setOptionStatus(
        group,
        this.dataset.optionsLoadingMessage || 'Searching filter options...',
        true
      );
      try {
        var response = await fetch(this.optionRequestUrl(group, query).toString(), {
          method: 'GET',
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { Accept: 'application/json' },
          signal: controller.signal
        });
        if (!response.ok) throw new Error('facet endpoint returned ' + response.status);
        var payload = await response.json();
        if (!payload || payload.group !== group || !Array.isArray(payload.options)) {
          throw new Error('invalid facet response');
        }
        var labels = [];
        payload.options.slice(0, MAX_OPTION_RESULTS).forEach(function (option) {
          var label = cleanLabel(option && option.label);
          if (label && labels.indexOf(label) === -1) labels.push(label);
        });
        this.optionCache.set(cacheKey, {
          labels: labels,
          expiresAt: Date.now() + OPTION_CACHE_TTL_MS
        });
        while (this.optionCache.size > OPTION_CACHE_LIMIT) {
          this.optionCache.delete(this.optionCache.keys().next().value);
        }
        if (this.optionSequences.get(group) === sequence &&
            this.currentOptionQuery(group) === normalizedQuery) {
          this.applyOptionResults(group, labels, query);
        }
      } catch (error) {
        if (this.optionSequences.get(group) === sequence &&
            this.currentOptionQuery(group) === normalizedQuery &&
            (timedOut || error.name !== 'AbortError')) {
          this.setOptionStatus(
            group,
            this.dataset.optionsErrorMessage || 'Filter options are temporarily unavailable.'
          );
        }
      } finally {
        window.clearTimeout(timeout);
        if (this.optionControllers.get(group) === controller) {
          this.optionControllers.delete(group);
        }
        var pendingQuery = this.optionPending.get(group);
        this.optionPending.delete(group);
        if (pendingQuery && normalizedSearchText(pendingQuery) !== normalizedQuery) {
          this.loadOptions(group, pendingQuery);
        } else if (this.currentOptionQuery(group).length < 2) {
          this.setOptionStatus(group, '');
        }
      }
    }

    currentOptionQuery(group) {
      var input = this.querySelector('[data-sfs-option-search="' + group + '"]');
      return normalizedSearchText(input ? input.value : '');
    }

    setOptionStatus(group, message, busy) {
      var status = this.querySelector('[data-sfs-option-status="' + group + '"]');
      var input = this.querySelector('[data-sfs-option-search="' + group + '"]');
      if (status) status.textContent = message || '';
      if (input) input.setAttribute('aria-busy', busy ? 'true' : 'false');
    }

    applyOptionResults(group, labels, query) {
      var list = this.querySelector('[data-sfs-option-list="' + group + '"]');
      if (!list) return;
      list.querySelectorAll('[data-sfs-dynamic-option]').forEach(function (row) {
        if (row.hasAttribute('data-sfs-expanded-option')) return;
        var input = row.querySelector('.filter-input');
        if (!input || !input.checked) row.remove();
      });
      labels.forEach(function (label) {
        this.ensureOptionRow(group, label, true);
      }.bind(this));
      this.filterLocalOptions(group, query);
      this.syncControls(this.desiredState || this.currentState);
      this.setOptionStatus(
        group,
        labels.length ? '' : (this.dataset.noOptionsMessage || 'No matching options.')
      );
    }

    filterLocalOptions(group, query) {
      var list = this.querySelector('[data-sfs-option-list="' + group + '"]');
      if (!list) return;
      var normalized = normalizedSearchText(query);
      list.querySelectorAll('[data-sfs-filter-item]').forEach(function (row) {
        syncRowHidden(row, normalized);
        if (!normalized &&
            row.hasAttribute('data-sfs-dynamic-option') &&
            !row.hasAttribute('data-sfs-expanded-option')) {
          var input = row.querySelector('.filter-input');
          if (!input || !input.checked) row.remove();
        }
      });
      this.syncEmbeddedOptions(group, list, normalized);
      var hasVisibleOption = Array.prototype.some.call(
        list.querySelectorAll('[data-sfs-filter-item]'),
        function (row) { return !row.hidden; }
      );
      this.setOptionStatus(
        group,
        normalized && !hasVisibleOption ? (this.dataset.noOptionsMessage || 'No matching options.') : ''
      );
    }

    // A group's values beyond the first 12 live only in the embedded
    // [data-sfs-more-options] JSON until "Show more" or a local search
    // materialises a row for them, through the same ensureOptionRow helper
    // "Show more" uses. A "Show more" row carries data-sfs-expanded-option
    // and is permanent; a row a search alone materialises carries only
    // data-sfs-dynamic-option -- the same convention already used for
    // remote brand/series results -- so the cleanup above removes it again
    // the moment the query clears (unless the shopper selected it). The
    // remaining count is recomputed from the DOM on every call so
    // "Show N more" never over- or under-promises.
    //
    // A tail label the last availability payload excluded, and the shopper
    // has not already selected, can never lead to a real result if
    // promoted -- so it must not inflate this count either. That is the
    // whole point: the number shown is how many of the hidden values are
    // still SELECTABLE, never the raw tail length. When no availability
    // payload has arrived yet for this group (this.availableOptions has no
    // entry), availability is unknown and every tail label still counts,
    // matching first paint and plain local-search filtering.
    //
    // Zero is reachable and reversible in both directions within the same
    // page (a query that matches nothing, then gets cleared; a selection
    // that narrows availability to nothing, then a chip removes it again),
    // so the control is only hidden at zero, never removed from the DOM.
    // Remaining of 1 or 2 is too small for a "Show N more" control: those
    // rows are promoted inline instead. Remaining of 3 or more keeps the
    // button. Hidden, not removed, so a chip removal that widens
    // availability back to 3+ can bring the same control back.
    syncEmbeddedOptions(group, list, normalizedQuery) {
      var scriptNode = this.querySelector('[data-sfs-more-options="' + group + '"]');
      var button = this.querySelector('[data-sfs-show-more="' + group + '"]');
      if (!scriptNode) {
        // Hidden, not removed -- same reversibility rule as the zero-
        // remaining branch below applies here too.
        if (button) button.hidden = true;
        return;
      }
      var labels;
      try {
        labels = JSON.parse(scriptNode.textContent || '[]');
      } catch (error) {
        return;
      }
      if (!Array.isArray(labels)) return;
      var renderedLabels = Array.prototype.map.call(
        list.querySelectorAll('[data-sfs-filter-link]'),
        function (link) { return link.dataset.sfsLabel; }
      );
      var available = this.availableOptions && this.availableOptions.get(group);
      var selectedValues = (this.desiredState || this.currentState).filters[group] || [];
      var remainingLabels = [];
      labels.forEach(function (rawLabel) {
        var label = cleanLabel(rawLabel);
        if (!label || renderedLabels.indexOf(label) !== -1) return;
        if (normalizedQuery && normalizedSearchText(label).indexOf(normalizedQuery) !== -1) {
          var row = this.ensureOptionRow(group, label, true);
          if (row) {
            syncRowHidden(row, normalizedQuery);
            renderedLabels.push(label);
            return;
          }
        }
        var selectable = !available || available.has(label) || selectedValues.indexOf(label) !== -1;
        if (selectable) remainingLabels.push(label);
      }.bind(this));
      if (remainingLabels.length > 0 && remainingLabels.length < SHOW_MORE_MIN_REMAINING) {
        remainingLabels.forEach(function (label) {
          var row = this.ensureOptionRow(group, label, false, true);
          if (!row) return;
          syncRowHidden(row, normalizedQuery);
          renderedLabels.push(label);
        }.bind(this));
        remainingLabels = remainingLabels.filter(function (label) {
          return renderedLabels.indexOf(label) === -1;
        });
      }
      var remaining = remainingLabels.length;
      if (!button) return;
      // Fewer than SHOW_MORE_MIN_REMAINING selectable values left in the
      // tail: nothing the control should reveal as a separate click. Hidden,
      // not removed -- remaining can rise again (a query clears, a chip
      // widens availability) and the same control must be able to return.
      button.hidden = remaining < SHOW_MORE_MIN_REMAINING;
      if (remaining >= SHOW_MORE_MIN_REMAINING) {
        button.textContent = button.textContent.replace(/\d+/, String(remaining));
      }
    }

    expandMoreOptions(group) {
      if (!group) return;
      var scriptNode = this.querySelector('[data-sfs-more-options="' + group + '"]');
      var button = this.querySelector('[data-sfs-show-more="' + group + '"]');
      if (!scriptNode) {
        // Hidden, not removed -- same reversibility rule as the zero-
        // remaining branch below applies here too.
        if (button) button.hidden = true;
        return;
      }
      var labels;
      try {
        labels = JSON.parse(scriptNode.textContent || '[]');
      } catch (error) {
        return;
      }
      if (!Array.isArray(labels)) return;
      var list = this.querySelector('[data-sfs-option-list="' + group + '"]');
      if (!list) return;
      var firstNewLink = null;
      var normalizedQuery = this.currentOptionQuery(group);
      this.syncEmbeddedOptions(group, list, normalizedQuery);
      if (button && button.hidden) {
        this.syncControls(this.desiredState || this.currentState);
        return;
      }
      labels.forEach(function (rawLabel) {
        var label = cleanLabel(rawLabel);
        if (!label) return;
        var existed = Array.prototype.some.call(
          list.querySelectorAll('[data-sfs-filter-link]'),
          function (link) { return link.dataset.sfsLabel === label; }
        );
        var row = this.ensureOptionRow(group, label, false, true);
        if (!row) return;
        if (!row.hasAttribute('data-sfs-initial-option')) {
          row.setAttribute('data-sfs-expanded-option', '');
          row.removeAttribute('data-sfs-dynamic-option');
        }
        syncRowHidden(row, normalizedQuery);
        if (!existed && !firstNewLink && !row.hidden) {
          firstNewLink = row.querySelector('[data-sfs-filter-link]');
        }
      }.bind(this));
      // Recompute from the DOM rather than unconditionally removing: a
      // label can fail to materialise here (MAX_OPTION_ROWS already
      // reached, and not selected), so the control must stay reversible
      // and keep reporting a true count instead of vanishing after one
      // click on a group that big.
      this.syncEmbeddedOptions(group, list, normalizedQuery);
      this.syncControls(this.desiredState || this.currentState);
      if (!firstNewLink) return;
      try {
        firstNewLink.focus({ preventScroll: true });
      } catch (error) {
        firstNewLink.focus();
      }
    }

    ensureOptionRow(group, label, dynamic, expanded) {
      var list = this.querySelector('[data-sfs-option-list="' + group + '"]');
      if (!list) return null;
      var existing = Array.prototype.find.call(
        list.querySelectorAll('[data-sfs-filter-link]'),
        function (link) { return link.dataset.sfsLabel === label; }
      );
      if (existing) return existing.closest('[data-sfs-filter-item]');
      var selectedValues = (this.desiredState || this.currentState).filters[group] || [];
      if (list.querySelectorAll('[data-sfs-filter-item]').length >= MAX_OPTION_ROWS &&
          selectedValues.indexOf(label) === -1) {
        return null;
      }
      var template = list.querySelector('[data-sfs-filter-item]');
      if (!template) return null;
      var row = template.cloneNode(true);
      row.removeAttribute('data-sfs-initial-option');
      row.removeAttribute('data-sfs-selected');
      var available = this.availableOptions && this.availableOptions.get(group);
      row.toggleAttribute('data-sfs-unavailable', !!available &&
        !available.has(label) && selectedValues.indexOf(label) === -1);
      row.removeAttribute('data-sfs-dynamic-option');
      row.removeAttribute('data-sfs-expanded-option');
      if (dynamic) row.setAttribute('data-sfs-dynamic-option', '');
      if (expanded) row.setAttribute('data-sfs-expanded-option', '');
      row.hidden = false;
      var input = row.querySelector('.filter-input');
      var inputLabel = row.querySelector('label[for]');
      var text = row.querySelector('.text');
      var link = row.querySelector('[data-sfs-filter-link]');
      this.dynamicOptionCount += 1;
      var id = 'sfsDynamic-' + this.instanceId + '-' + this.dynamicOptionCount;
      if (input) {
        input.id = id;
        input.checked = false;
        input.disabled = true;
        input.setAttribute('tabindex', '-1');
        input.setAttribute('aria-hidden', 'true');
        input.removeAttribute('name');
        input.removeAttribute('value');
      }
      if (inputLabel) inputLabel.setAttribute('for', id);
      if (text) text.textContent = label;
      if (link) {
        link.dataset.sfsLabel = label;
        link.dataset.sfsGroup = group;
        link.removeAttribute('aria-current');
      }
      list.appendChild(row);
      return row;
    }

    syncControls(rawState) {
      var state = normalizeState(rawState || this.currentState);
      this.querySelectorAll('[data-sfs-native-link]').forEach(function (link) {
        var url = new URL(link.getAttribute('href'), window.location.origin);
        var current = new URL(window.location.href);
        // Native links supply the complete filter state. Carry only page
        // context from the visible URL, never stale custom selections.
        current.searchParams.forEach(function (value, key) {
          if (key.indexOf('filter.') === 0 || key.indexOf('sfs_') === 0 || key === 'page') return;
          if (!url.searchParams.has(key)) url.searchParams.append(key, value);
        });
        Array.from(url.searchParams.keys()).forEach(function (key) {
          if (key.indexOf('sfs_') === 0 || key === 'page') url.searchParams.delete(key);
        });
        link.href = url.toString();
      });
      PUBLIC_GROUPS.forEach(function (group) {
        (state.filters[group] || []).forEach(function (label) {
          this.ensureOptionRow(group, label, true);
        }.bind(this));
      }.bind(this));
      this.querySelectorAll('[data-sfs-filter-link]').forEach(function (link) {
        var group = link.dataset.sfsGroup;
        var label = cleanLabel(link.dataset.sfsLabel);
        var selected = !!(state.filters[group] && state.filters[group].indexOf(label) >= 0);
        var row = link.closest('[data-sfs-filter-item]');
        var input = row && row.querySelector('.filter-input');
        if (input) input.checked = selected;
        if (row) row.toggleAttribute('data-sfs-selected', selected);
        if (selected) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
        var action = selected ? this.dataset.removeAction : this.dataset.addAction;
        var groupLabel = link.dataset.sfsGroupLabel || group;
        link.setAttribute('aria-label', [action, groupLabel, label].filter(Boolean).join(' '));
        link.href = this.visibleUrl(this.stateWithSpecificToggle(state, group, label)).toString();
      }.bind(this));

      this.syncActiveFilterChips(state);
      this.querySelectorAll('.sort-section input[type="radio"]').forEach(function (input) {
        input.checked = input.value === state.sort;
      });
      this.querySelectorAll('.sort-section-value').forEach(function (valueNode) {
        var checked = valueNode.closest('.sort-section').querySelector('input[type="radio"]:checked');
        var label = checked && checked.parentElement.querySelector('label .text');
        if (label) valueNode.textContent = label.textContent;
      });
      var count = this.querySelector('.collection-count');
      this.querySelectorAll('.jsFilterResultCount').forEach(function (node) {
        if (count) node.textContent = count.textContent.trim();
      });
    }

    // Renders the top-grid active-filter chips through the exact same
    // window.SFS_ACTIVE_FILTERS.render helper collection-search-active-filters.liquid
    // uses to seed them before first paint, so this call is the only place
    // that keeps them in sync with every state transition (initial load,
    // success, failure rollback, popstate, snapshot restore) the same way
    // it already keeps every other control in sync. Native filter.* state
    // owns its own server-rendered active-controls block, so this surface
    // stays suppressed whenever a native param is present.
    syncActiveFilterChips(state) {
      var helper = window.SFS_ACTIVE_FILTERS;
      if (!helper || typeof helper.render !== 'function') return;
      var nativeActive = this._sfsNativeCommitted || this.hasUnsupportedNativeFilters(new URL(window.location.href));
      helper.render(
        nativeActive ? {} : state.filters,
        orderedChipGroups(this.querySelector('[data-sfs-active-controls]'))
      );
    }

    stateWithSpecificToggle(baseState, group, label) {
      var state = cloneState(baseState);
      var values = state.filters[group] ? state.filters[group].slice() : [];
      var index = values.indexOf(label);
      if (index >= 0) values.splice(index, 1);
      else if (values.length < MAX_VALUES_PER_GROUP && selectedCount(state) < MAX_TOTAL_VALUES) {
        values.push(label);
      }
      if (values.length) state.filters[group] = values;
      else delete state.filters[group];
      state.page = 1;
      return normalizeState(state);
    }

    // Unlike stateWithSpecificToggle, this never adds: an active-filter chip
    // is a remove-only control, so a value already absent from baseState
    // (a stale or duplicate click on a chip the previous click already
    // dropped) is a no-op, not a re-add.
    stateWithFilterRemoved(baseState, group, label) {
      var state = cloneState(baseState);
      var values = (state.filters[group] || []).filter(function (existing) {
        return existing !== label;
      });
      if (values.length) state.filters[group] = values;
      else delete state.filters[group];
      state.page = 1;
      return normalizeState(state);
    }

    onPopState() {
      if (this.hasUnsupportedNativeFilters(new URL(window.location.href)) ||
          this.querySelector('[data-sfs-native-active-controls]')) {
        window.location.reload();
        return;
      }
      this.load(this.stateFromVisibleUrl(new URL(window.location.href)), { historyMode: 'none' });
    }

    restoreFocus(label) {
      if (!label) return;
      var focusable = Array.prototype.find.call(
        this.querySelectorAll('[data-sfs-filter-link], .pagination-holder a, button, input'),
        function (node) {
          return node.dataset.sfsLabel === label ||
            node.value === label ||
            node.getAttribute('title') === label ||
            node.textContent.trim() === label;
        }
      );
      if (!focusable) {
        focusable = this.querySelector('[data-sfs-filter-rail] summary, .btn-filter');
      }
      if (!focusable) return;
      try {
        focusable.focus({ preventScroll: true });
      } catch (error) {
        focusable.focus();
      }
    }

    scrollToGrid() {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }
  }

  if (!window.customElements.get('collection-search-filters')) {
    window.customElements.define('collection-search-filters', CollectionSearchFilters);
  }
})();
